import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {checkPasswordsMatch, validateEmail, validatePassword} from '../../utils';
import MandatoryInput from '../../common/components/layout/MandatoryInput';
import LoginButton from '../../common/components/LoginButton';
import {LoginBackButton} from '../../common/components/StyledComp';
import Tooltip from '../../common/components/Tooltip';

const RegisterStep2 = props => {
  const {t, newUser, setNewUser, submitted, setSubmitted, setStep, registerError, setError, setPasswordsMatch, passwordsMatch, onSubmit} = props;
  const [validPassword, setValidPassword] = useState(true);
  const [passwordConfirmation, setPasswordConf] = useState('');
  const [cguAccepted, setCguAccepted] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  return (
    <Row>
      <Col xs={{span: 10, offset: 1}}>
        <Row className="spaced-input">
          <MandatoryInput
            name="email"
            type="text"
            title={t('reg.form.field.email')}
            value={newUser.email}
            onChange={(name, text) => {
              setNewUser({...newUser, email: text});
              setError(null);
            }}
            show={submitted && (registerError === t('reg.existingEmail') || !validateEmail(newUser.email))}
            customText={registerError === null ? t('reg.invalidEmail') : registerError}
          />
        </Row>
        <Row className="spaced-input">
          <MandatoryInput
            name="password"
            type="password"
            title={t('reg.form.field.pass')}
            value={newUser.password}
            onChange={(name, text) => {
              setNewUser({...newUser, password: text});
              setPasswordsMatch(checkPasswordsMatch(passwordConfirmation, text) || passwordConfirmation === '');
              setValidPassword(validatePassword(text));
            }}
            show={(submitted && newUser.password === '') || !validPassword}
            customText={!validPassword ? t('reg.invalidPassword') : null}
          />
        </Row>
        <Row className="spaced-input">
          <MandatoryInput
            name="passwordConfirmation"
            type="password"
            title={t('reg.form.field.passConf')}
            value={passwordConfirmation}
            onChange={(name, text) => {
              setPasswordConf(text);
              setPasswordsMatch(checkPasswordsMatch(newUser.password, text));
            }}
            show={(submitted && passwordConfirmation === '') || !passwordsMatch}
            customText={!passwordsMatch ? t('reg.passwordsMatch') : null}
          />
        </Row>
        <Row className="spaced-input">
          <MandatoryInput
            name="mobilePhone"
            type="number"
            title={t('reg.form.field.phoneNumber')}
            value={newUser.mobilePhone}
            onChange={(name, text) => {
              setError(null);
              setNewUser({...newUser, mobilePhone: text});
            }}
            show={submitted && (registerError === t('reg.existingPhone') || !newUser.mobilePhone)}
            customText={registerError === null ? null : registerError}
          />
        </Row>
        <Row className="spaced-input">
          <Col xs={12}>
            <label className="checkbox">
              <input
                type="checkbox"
                name="cgu"
                checked={cguAccepted}
                onChange={e => {
                  setError(null);
                  setCguAccepted(e.target.checked);
                }}
              />
              * J'ai lu et j'accepte les <a href="/cgu" target="_blank" rel="noopener noreferrer">conditions générales d'utilisation</a>
            </label>
            <Tooltip show={submitted && !cguAccepted} color={'red'}>
              {t('requiredField')}
            </Tooltip>
          </Col>
          <Col xs={12}>
            <label className="checkbox">
              <input
                type="checkbox"
                name="privacy"
                checked={privacyAccepted}
                onChange={e => {
                  setError(null);
                  setPrivacyAccepted(e.target.checked);
                }}
              />
              * J'ai lu et j'accepte la <a href="/privacy" target="_blank" rel="noopener noreferrer">politique de confidentialité</a>
            </label>
            <Tooltip show={submitted && !privacyAccepted} color={'red'}>
              {t('requiredField')}
            </Tooltip>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <LoginBackButton onClick={() => {
              setStep(1);
              setSubmitted(false);
            }}>
              {t('reg.back')}
            </LoginBackButton>
          </Col>
          <Col xs={12} sm={6}>
            <LoginButton onClick={() => {
              if (privacyAccepted && cguAccepted) {
                onSubmit();
              }
              setSubmitted(true);
            }}>
              {t('reg.form.btnValid')}
            </LoginButton>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

RegisterStep2.propTypes = {
  t: PropTypes.func.isRequired,
  newUser: PropTypes.object.isRequired,
  setNewUser: PropTypes.func.isRequired,
  submitted: PropTypes.bool.isRequired,
  setSubmitted: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  registerError: PropTypes.object,
  setError: PropTypes.func.isRequired,
  setPasswordsMatch: PropTypes.func.isRequired,
  passwordsMatch: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default withTranslation('login')(RegisterStep2);
